import styled from 'styled-components';

// Components
import { DateTime } from '../../../../inputs/DateTime';

// Types
import { TrHeaderProps, ThInputProps } from './types';
import { Typography } from '../../../Typography';

export const Container = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
`;

export const TrHeader = styled.tr<TrHeaderProps>`
  background-color: ${({ theme }) => theme.colors.greyDark};
  height: ${({ theme }) => theme.spacing.l};
  ${(props) =>
    props.empty && {
      height: 0,
    }};
  & th {
    width: calc(100% / 6);
  }
`;

export const ThStyled = styled.th<ThInputProps>`
  max-width: 25rem;
  height: ${({ theme }) => theme.spacing.xl};
  padding: ${({ theme }) => theme.spacing.xxxs}
    ${({ theme }) => theme.spacing.xxs};
  font-size: ${({ theme }) => theme.fontSize.S};
  background-color: ${({ theme }) => theme.colors.white};
  vertical-align: middle;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const Th = styled.th`
  vertical-align: middle;
`;

// La celda es contenedor de consulta: la fecha y la hora se apilan según el
// ancho REAL de la celda, no el de la pantalla (ver `InputDate`).
export const ContainerInput = styled.div`
  display: flex;
  justify-content: center;
  container: attention-cell / inline-size;
`;

export const ThInput = styled(ThStyled)`
  background-color: ${(props) =>
    props.disabled
      ? props.theme.colors.greyLight
      : props.theme.colors.backgroundLila};
  padding: ${({ theme }) => theme.spacing.xxs}
    ${({ theme }) => theme.spacing.xxs};
`;

export const InputDate = styled(DateTime)`
  .container-inputs {
    gap: 0;
    border-radius: 0.5rem;
  }

  .container-inputs:focus-within {
    outline: 0.1rem solid ${({ theme }) => theme.colors.black};
  }

  .input-date {
    border: none;
    outline: none;
    height: ${({ theme }) => theme.spacing.l};
    // 13.6rem: cabe el placeholder «dd/mm/aaaa» a 16 px (114 px + padding).
    max-width: 13.6rem;
    border-bottom: ${(props) =>
      props.borderError ? '0.1rem solid red' : 'none'};
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .input-hour {
    border: none;
    outline: none;
    height: ${({ theme }) => theme.spacing.l};
    border-bottom: ${(props) =>
      props.borderError ? '0.1rem solid red' : 'none'};
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  // Tablet: letra de 16 px y 44 px de alto (mínimo táctil). Antes, en vertical,
  // la hora iba en una caja fija de 40 px a 12 px y los minutos se salían.
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    span,
    .input-date,
    .input-number {
      font-size: ${({ theme }) => theme.fontSize.S};
    }
    .input-date,
    .input-hour {
      height: 4.4rem;
    }
    .input-number {
      width: 2ch;
    }
  }

  // Celda estrecha (tablet vertical: ~150 px): fecha arriba y hora debajo, las
  // dos a todo el ancho. En fila caben desde 200 px (136 fecha + 64 hora). En px y no en rem:
  // en la condición de un @container el rem no es el de 10 px del :root.
  @container attention-cell (max-width: 199px) {
    .container-inputs {
      flex-direction: column;
      align-items: stretch;
      gap: ${({ theme }) => theme.spacing.xxxs};
    }
    .input-date {
      width: 100%;
      max-width: none;
      padding: 0 ${({ theme }) => theme.spacing.xxs};
      text-align: center;
      border-radius: 0.5rem;
    }
    .input-hour {
      justify-content: center;
      border-radius: 0.5rem;
    }
  }
`;

export const Tr = styled.tr`
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
`;

export const TrStyled = styled.tr`
  background-color: ${({ theme }) => theme.colors.verySoftRed};
`;

export const Text = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize.M};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.S};
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const InputOthers = styled.input`
  border: none;
  outline: none;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.M};
  background-color: ${({ theme }) => theme.colors.white};
  &:disabled {
    color: ${({ theme }) => theme.colors.black};
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.S};
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
